import { render, staticRenderFns } from "./claim_button.vue?vue&type=template&id=6c3bc1d9&scoped=true"
import script from "./claim_button.vue?vue&type=script&lang=js"
export * from "./claim_button.vue?vue&type=script&lang=js"
import style0 from "./claim_button.vue?vue&type=style&index=0&id=6c3bc1d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3bc1d9",
  null
  
)

export default component.exports